import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "28fc4430-a78d-4124-9799-90eaff901b49",
    options: { imageUrl: `${config.ASSETS_URL}/02/15/task/task-1-item-1.png` },
  },
  {
    id: "4998556d-5d27-4ab6-a759-fb07f8d5d882",
    options: { imageUrl: `${config.ASSETS_URL}/02/15/task/task-1-item-2.png` },
  },
  {
    id: "39dac48d-37ba-4caf-ae22-a11a7f284247",
    options: { imageUrl: `${config.ASSETS_URL}/02/15/task/task-1-item-3.png` },
  },
  {
    id: "da11a3c3-ca3b-444f-a561-fc54477be51e",
    options: { imageUrl: `${config.ASSETS_URL}/02/15/task/task-1-item-4.png` },
  },
];

const groups = [
  { id: "3fdf48b9-e6a7-49cf-842a-ca0fc4bcf7c2", content: "Mono", options: {} },
  { id: "c25009bb-0ed9-46d7-9a13-971849e57da9", content: "Stereo", options: {} },
  { id: "e4f81bb3-d4f7-4b49-a79f-83a7fead1323", content: "Binaural", options: {} },
];

export const task: Task = {
  id: "5dfd71ba-9838-490f-a772-3496f89339e8",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "3fdf48b9-e6a7-49cf-842a-ca0fc4bcf7c2", itemsId: ["39dac48d-37ba-4caf-ae22-a11a7f284247"] },
    { groupId: "c25009bb-0ed9-46d7-9a13-971849e57da9", itemsId: ["4998556d-5d27-4ab6-a759-fb07f8d5d882"] },
    {
      groupId: "e4f81bb3-d4f7-4b49-a79f-83a7fead1323",
      itemsId: ["28fc4430-a78d-4124-9799-90eaff901b49", "da11a3c3-ca3b-444f-a561-fc54477be51e"],
    },
  ],
};
